import { render, staticRenderFns } from "./ButtonShortcutEditor.vue?vue&type=template&id=769821ec"
import script from "./ButtonShortcutEditor.vue?vue&type=script&lang=ts"
export * from "./ButtonShortcutEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports